(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/views/system-row-container.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/views/system-row-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.keno=_svs.keno||{};
_svs.keno.components=_svs.keno.components||{};
_svs.keno.components.play=_svs.keno.components.play||{};
_svs.keno.components.play.templates=_svs.keno.components.play.templates||{};
svs.keno.components.play.templates.system_row_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"boardSettingsRegion\" class=\"keno-system\"></div>\n<div id=\"boardContainerRegion\" class=\"grid-row\"></div>\n<div class=\"grid-row\">\n  <div id=\"rowsRegion\" class=\"col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-1 col-lg-5 col-lg-offset-2\"></div>\n</div>\n<div id=\"campaignCardRegion\" class=\"grid-row margin-top\"></div>\n\n";
},"useData":true});
Handlebars.partials['svs-keno-components-play-system_row_container'] = svs.keno.components.play.templates.system_row_container;
})(svs, Handlebars);


 })(window);